export const SideBarWidth = 260;